import * as ss from 'superstruct';

export type JsonPrimitive = string | number | boolean | null;

export type JsonObject = { [key: string]: JsonValue };

export type JsonValue = JsonPrimitive | JsonValue[] | JsonObject;

/** Validates a whole JSON value, recursively. */
export const jsonValueStruct: ss.Describe<JsonValue> = ss.lazy(() =>
  ss.union([
    ss.string(),
    ss.number(),
    ss.boolean(),
    ss.literal(null),
    ss.array(jsonValueStruct),
    ss.record(ss.string(), jsonValueStruct),
  ]),
);

export const jsonObjectStruct: ss.Describe<JsonObject> = ss.record(
  ss.string(),
  jsonValueStruct,
);

/** Shallow: `value` is already known to be JSON. */
export const isJsonObject = (
  value: JsonValue | undefined,
): value is JsonObject =>
  value !== null &&
  value !== undefined &&
  !Array.isArray(value) &&
  ss.is(value, ss.record(ss.string(), ss.any()));

export const isJsonArray = (
  value: JsonValue | undefined,
): value is JsonValue[] => Array.isArray(value);

export const isJsonString = (value: JsonValue | undefined): value is string =>
  ss.is(value, ss.string());

export const isJsonNumber = (value: JsonValue | undefined): value is number =>
  ss.is(value, ss.number());

export const isJsonBoolean = (value: JsonValue | undefined): value is boolean =>
  ss.is(value, ss.boolean());
